import { Component } from '@angular/core';

@Component({
  selector: 'lib-mango-event-analytics',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'mango-event-analytics';
}
